module.exports = __webpack_public_path__ + "img/Navbar-Logo-03.d77d4997.png";